import { useTranslation } from 'next-i18next'

import { NAVIGATION_ICONS } from '@/constants/navigationAssets'

import CommonButton from '@/components/form/Button/CommonButton'

import BtnGlobalCustomStyles from '@/components/form/Button/button.customStyles'

import {
  MobileFiltersButtonWrapper,
  ContentWrapper
} from './FilterButton.styled'

const FilterButton = ({
  handleOverlayToggle,
  onMapModalOptn
}: {
  handleOverlayToggle: () => void
  onMapModalOptn: () => void
}) => {
  const { t } = useTranslation('parkings')
  return (
    <MobileFiltersButtonWrapper
      isFixed={true}
      isVisible={true}
      data-test-id="mobile-filters-button-wrapper"
    >
      <CommonButton
        variant="options"
        onClick={handleOverlayToggle}
        data-test-id="options-button"
        customStyle={[
          BtnGlobalCustomStyles.commonBlock,
          BtnGlobalCustomStyles.showResultCommonStyles,
          BtnGlobalCustomStyles.filter
        ]}
      >
        <ContentWrapper data-test-id="options-content-wrapper">
          <img src={NAVIGATION_ICONS.options} alt="Options" loading="lazy" />
          <span>{t('searchNearParking.filters.options')}</span>
        </ContentWrapper>
      </CommonButton>
      <CommonButton
        variant="options"
        onClick={onMapModalOptn}
        data-test-id="map-button"
        customStyle={[
          BtnGlobalCustomStyles.commonBlock,
          BtnGlobalCustomStyles.showResultCommonStyles,
          BtnGlobalCustomStyles.filter
        ]}
      >
        <ContentWrapper data-test-id="map-content-wrapper">
          <img
            src={NAVIGATION_ICONS.mapButtonMobile}
            alt="Map Button"
            loading="lazy"
          />
          <span>{t('searchNearParking.filters.map')}</span>
        </ContentWrapper>
      </CommonButton>
    </MobileFiltersButtonWrapper>
  )
}

export default FilterButton
